// App.js
import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./globals.css";

// Import pages
import Login from "./pages/LoginPage"; 
import SignUp from "./pages/SignupPage";
import UploadPage from "./pages/UploadPage";
import InventoryPage from "./pages/InventoryPage";
import SettingsPage from "./pages/SettingsPage";
import DataframePage from "./pages/DataframePage";
import AuthActionPage from "./pages/AuthActionPage";
import SubscribePage from "./pages/SubscribePage";

// Context
import { AuthContext } from "./context/AuthContext";

function App() {

  // Get currentUser and loading state from AuthContext.
  const { currentUser, loading } = useContext(AuthContext);
  // Determine authentication based on currentUser.
  const isAuthenticated = Boolean(currentUser);

  // Show a loading indicator while waiting for auth to initialize.
  if (loading) {
    return <div>Loading...</div>;
  }

  // PrivateRoute to guard protected pages
  const PrivateRoute = ({ children }) => {
    return isAuthenticated ? children : <Navigate to="/login" />;
  };

  return (
    <Router>
      <Routes>

        {/* Login route - always publicly accessible */}
        <Route
          path="/login"
          element={<Login />}
        />
        <Route
          path="/signup"
          element={<SignUp />}
        />

        {/* Protected route - can only access if isAuthenticated */}
        <Route
          path="/upload"
          element={
            <PrivateRoute>
              <UploadPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/inventory"
          element={
            <PrivateRoute>
              <InventoryPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/dataframe"
          element={
            <PrivateRoute>
              <DataframePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <SettingsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/subscribe"
          element={
            <PrivateRoute>
              <SubscribePage />
            </PrivateRoute>
          }
        /> 
       
        {/* Public route - can access without authentication */}
        <Route
          path="/auth"
          element={<AuthActionPage />}
        />

        {/* Default route -> if not logged in, go to /login, else go to /main */}
        <Route
          path="/"
          element={
            isAuthenticated ? <Navigate to="/upload" /> : <Navigate to="/login" />
          }
        />

        {/* 404 catch-all */}
        <Route
          path="*"
          element={<h2 style={{ textAlign: "center" }}>Page Not Found</h2>}
        />

      </Routes>
    </Router>
  );
}

export default App;